export const FILTER_SET_ID = 'FILTER_SET'

export function isFilterSet(filter) {
    return (filter || {}).id === FILTER_SET_ID
}
